import { render, staticRenderFns } from "./custom-company-example.vue?vue&type=template&id=82101214&scoped=true&"
import script from "./custom-company-example.vue?vue&type=script&lang=js&"
export * from "./custom-company-example.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-example.vue?vue&type=style&index=0&id=82101214&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82101214",
  null
  
)

export default component.exports